import zh_CN from '../../date-picker/locale/zh_CN';
export default zh_CN;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/calendar/locale/zh_CN.js
// module id = 273
// module chunks = 0